"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconLandlordFilled = function IconLandlordFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.38,24h-.19L33,26h5.34a5.11,5.11,0,0,1,2.59-2.59V19.57a4.91,4.91,0,0,1-2-1.57,5.26,5.26,0,0,1-.59-1H22.47a5.26,5.26,0,0,1-.59,1,4.91,4.91,0,0,1-2,1.57v.61a8.08,8.08,0,0,1,2-.23,8.48,8.48,0,0,1,5,1.64l1.19.86a2.56,2.56,0,0,1-.19-.95,2.5,2.5,0,1,1,2.5,2.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.88,20.47V18.76a4.23,4.23,0,0,0,1-.42,4.14,4.14,0,0,0,.48-.34,3.93,3.93,0,0,0,.86-1,4.23,4.23,0,0,0,.42-1H39.12a4.23,4.23,0,0,0,.42,1,3.93,3.93,0,0,0,.86,1,4.14,4.14,0,0,0,.48.34,4.23,4.23,0,0,0,1,.42v5.48a3.54,3.54,0,0,0-1,.42A3.91,3.91,0,0,0,39.54,26a3.54,3.54,0,0,0-.42,1h-5a2.73,2.73,0,0,1,.54,2h9.23V14h-27v7.23l1.95-.74Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.9,31.32l-.31,0L32,33l-6.43-2.75A.95.95,0,0,1,25.08,29a.93.93,0,0,1,.87-.58,1,1,0,0,1,.33.06l1.38.52,3.6,1.35a1.74,1.74,0,0,0,.63.11,1.79,1.79,0,0,0,1.69-1.22,1.05,1.05,0,0,0,.06-.24,1.78,1.78,0,0,0-.7-1.77L32.63,27l-1.38-1-5-3.61A7.57,7.57,0,0,0,21.84,21a7.76,7.76,0,0,0-2,.26c-.24.06-.47.14-.7.22l-.3.11-2,.75-1.36.51a3.08,3.08,0,0,1-1.08.2H9V21.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V33h5.58a2.46,2.46,0,0,1,.81.14L31,38.82A3.13,3.13,0,0,0,32,39a3.06,3.06,0,0,0,1-.16l11.47-3.39a2.11,2.11,0,0,0-.59-4.13Z",
    fill: color
  }));
};

IconLandlordFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconLandlordFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconLandlordFilled;
exports.default = _default;